import { render, staticRenderFns } from "./gameObjCard.vue?vue&type=template&id=192a6a77&scoped=true"
import script from "./gameObjCard.vue?vue&type=script&lang=js"
export * from "./gameObjCard.vue?vue&type=script&lang=js"
import style0 from "./gameObjCard.vue?vue&type=style&index=0&id=192a6a77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a6a77",
  null
  
)

export default component.exports